<wl-experience-editor>
  <ng-template wlLive>
    @if (backLink$ | async; as backLink) {
      <wl-back-button [backLink]="backLink"></wl-back-button>
    }
  </ng-template>
  <ng-template wlPreview>
    @if (backLink$ | async; as backLink) {
      <fa-icon class="me-1" icon="angle-left" size="lg"></fa-icon>
      <span
        >Terugkeerknop (stel deze in door "backUrl" op de pagina in te
        vullen)</span
      >
    }
  </ng-template>
</wl-experience-editor>
